/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { Component, OnInit } from '@angular/core';
import { AnalyticsService } from './@core/utils/analytics.service';
import { IconsService } from '../app/@core/icons/icons.service';
import { UserQuery } from './@core/akita-stores/stores/user/user.query';
import { NgxPermissionsService } from 'ngx-permissions';
import { ServiceCentersService } from './@core/akita-stores/entity-stores/sercice-centers/service-centers.service';
import { HttpClient } from '@angular/common/http';
import { UserService } from './@core/akita-stores/stores/user/user.service';
import { environment } from './../environments/environment';
import { BookingListService } from './@core/akita-stores/entity-stores/bookings/bookings.service';
import { ServiceCentersQuery } from './@core/akita-stores/entity-stores/sercice-centers/service-centers.query';
import { forkJoin } from 'rxjs';
import { ConfigService } from './@core/akita-stores/stores/config/config.service';
import { Router } from '@angular/router';
import { BayService } from './@core/akita-stores/entity-stores/bays/bays.service';
import { EntitiesService } from './@core/akita-stores/entity-stores/entities/entities.service';
import { BookingCalendarService } from './@core/akita-stores/stores/booking-calendar/booking-calendar.store';
import { SessionService } from './@core/akita-stores/stores/session/session.service';

@Component({
  selector: 'ngx-app',
  template: '<router-outlet></router-outlet>',
})
export class AppComponent implements OnInit {
  getServiceCenters$;
  isLogin: boolean = false;

  constructor(
    private analytics: AnalyticsService,
    private serviceCentersService: ServiceCentersService,
    private ngxpermissionsService: NgxPermissionsService,
    private iconService: IconsService,
    private userService: UserService,
    private userQuery: UserQuery,
    private bookingListService: BookingListService,
    private http: HttpClient,
    private bayService: BayService,
    private serviceCentersQuery: ServiceCentersQuery,
    private config: ConfigService,
    private router: Router,
    private entityService: EntitiesService,
    private bookingCalendarService: BookingCalendarService,
    private sestionService: SessionService,
  ) {
    this.entityService.setTheme();
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.iconService.registerResources();
    this.userQuery.isLogin$.subscribe(data => this.isLogin = data.isLogin);
  }

  ngOnInit() {
    const validVersion = this.config.checkVersion();
    if (!validVersion) {
      // logout for refresh the all stores
      this.sestionService.logout();
      return;
    }
    this.config.setLoading(false);
    this.analytics.trackPageViews();
    // console.log('test: 3')
    // this call is to get the service centers configured
    this.serviceCentersService.getServiceCenters().subscribe(() => {
    //   if (this.isLogin) {
    //     this.bayService.getBays().subscribe();
    //   }
      this.config.setLoading(false);
    });

    // reset the view date and filter list
    this.bookingCalendarService.resetViewDate();
    this.bookingCalendarService.updateIsViewAllBooking(false);
    this.bookingListService.updateFilterList([]);
  }
}
